import { default as aboutcGvMViY0SnMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexItLcRhC3SOMeta } from "/opt/buildhome/repo/pages/alternatives/index.vue?macro=true";
import { default as _91slug_93x8nwzxMykbMeta } from "/opt/buildhome/repo/pages/blog/[slug].vue?macro=true";
import { default as indexnCitm8tluDMeta } from "/opt/buildhome/repo/pages/blog/index.vue?macro=true";
import { default as contactupLWW5VsuQMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as features7k68KUoyy4Meta } from "/opt/buildhome/repo/pages/features.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as lean_45canvasf49tyxurNQMeta } from "/opt/buildhome/repo/pages/lean-canvas.vue?macro=true";
import { default as _91slug_93zwznHQgrgNMeta } from "/opt/buildhome/repo/pages/people/[slug].vue?macro=true";
import { default as indexddrjzUXrecMeta } from "/opt/buildhome/repo/pages/people/index.vue?macro=true";
import { default as _91slug_93xsAOt4mlffMeta } from "/opt/buildhome/repo/pages/pitches/[slug].vue?macro=true";
import { default as index7yKL1l9h0gMeta } from "/opt/buildhome/repo/pages/pitches/index.vue?macro=true";
import { default as portfolioOEYTPLG89MMeta } from "/opt/buildhome/repo/pages/portfolio.vue?macro=true";
import { default as indexVrpVjnZSa3Meta } from "/opt/buildhome/repo/pages/services/index.vue?macro=true";
import { default as _91slug_93FmhTEiPl31Meta } from "/opt/buildhome/repo/pages/tools/[slug].vue?macro=true";
import { default as index4aR1mPd18dMeta } from "/opt/buildhome/repo/pages/tools/index.vue?macro=true";
import { default as value_45based_45pricing_45canvasEjFjlI0YrRMeta } from "/opt/buildhome/repo/pages/value-based-pricing-canvas.vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "alternatives___en",
    path: "/alternatives",
    component: () => import("/opt/buildhome/repo/pages/alternatives/index.vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    component: () => import("/opt/buildhome/repo/pages/blog/[slug].vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog/index.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "features___en",
    path: "/features",
    component: () => import("/opt/buildhome/repo/pages/features.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "lean-canvas___en",
    path: "/lean-canvas",
    component: () => import("/opt/buildhome/repo/pages/lean-canvas.vue")
  },
  {
    name: "people-slug___en",
    path: "/people/:slug()",
    component: () => import("/opt/buildhome/repo/pages/people/[slug].vue")
  },
  {
    name: "people___en",
    path: "/people",
    component: () => import("/opt/buildhome/repo/pages/people/index.vue")
  },
  {
    name: "pitches-slug___en",
    path: "/pitches/:slug()",
    component: () => import("/opt/buildhome/repo/pages/pitches/[slug].vue")
  },
  {
    name: "pitches___en",
    path: "/pitches",
    component: () => import("/opt/buildhome/repo/pages/pitches/index.vue")
  },
  {
    name: "portfolio___en",
    path: "/portfolio",
    component: () => import("/opt/buildhome/repo/pages/portfolio.vue")
  },
  {
    name: "services___en",
    path: "/services",
    component: () => import("/opt/buildhome/repo/pages/services/index.vue")
  },
  {
    name: "tools-slug___en",
    path: "/tools/:slug()",
    component: () => import("/opt/buildhome/repo/pages/tools/[slug].vue")
  },
  {
    name: "tools___en",
    path: "/tools",
    component: () => import("/opt/buildhome/repo/pages/tools/index.vue")
  },
  {
    name: "value-based-pricing-canvas___en",
    path: "/value-based-pricing-canvas",
    component: () => import("/opt/buildhome/repo/pages/value-based-pricing-canvas.vue")
  }
]